import { HttpClient } from './serviceBase';

class ProductsService {
    GetById = async (productId) => 
        await HttpClient.Get(`/api/products/${productId}`);

    GetByRefId = async (refId) => 
        await HttpClient.Get(`/api/products/sku?refId=${refId}`);
        
    GetAllByRefIds = async (refIds) => 
        await HttpClient.Post(`/api/products/skus`, refIds);
}

export default new ProductsService();